const contact = document.getElementById('contact')

document.addEventListener('DOMContentLoaded', () => {
  if (contact) {
    // URLパラメータを取得する関数
    const getParameterByName = (name) => {
      const url = window.location.href;
      name = name.replace(/[[\]]/g, '\\$&');
      const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
      const results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }

    // パラメータが 'reason' の場合、チェックボックスをチェック
    if (getParameterByName('reason') === 'recruit') {
      const checkboxes = document.querySelectorAll('input[name="checkbox-569[]"]');
      checkboxes.forEach((checkbox) => {
        if (checkbox.value === '採用に応募する') {
          checkbox.checked = true;
        }
      });
    }
  }
});
